<template>
    <DIcon
        :name="iconName"
        size="sm"
        class="icon"
        :class="{ 'copied': copied }"
        @click="copyToClipboard"
    />
</template>

<script>
export default {
    name: 'CopyToClipboard',
    props: {
        value: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            copied: false,
            duration: 1500
        }
    },
    computed: {
        iconName () {
            return this.copied ? 'check-circle-outline' : 'content-copy'
        }
    },
    methods: {
        copyToClipboard: function () {
            try {
                navigator.clipboard.writeText(this.value)

                this.copied = true
                setTimeout(() => {
                    this.copied = false
                }, this.duration)
            } catch (err) {
                console.error('Failed to copy:', err)
            }
        }
    }
}
</script>

<style scoped>
.icon {
    cursor: pointer;
    transition: transform 0.15s ease, color 0.2s ease;
}

.icon.copied {
    color: #4caf50;
}
</style>
